import styled from 'styled-components';

export const MyInfoStyles = styled.div`
  height: 60px;
  display: flex;
  padding: 16px;
  gap: 10px;
  align-items: center;
  text-align: center;

  .avatar {
    border-radius: 50%;
    object-fit: cover;
  }

  .info-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    max-width: calc(100% - 80px);

    .name-container {
      max-width: 100%;

      section {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }

  .pro-badge-container {
    &:not([data-ispro='true']) {
      svg {
        display: none;
      }
    }
  }

  .name-container {
    text-align: left;

    .name {
      font-weight: 600;
      font-size: 18px;
      line-height: 24px;
      user-select: none;
      color: #1d201f;
    }
  }

  .action-button {
    text-align: start;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;

    color: #177590;
    background: none;
  }
`;

export const StyledMyInfoContainerSkeleton = styled.div`
  justify-content: start;
  gap: 5px;
  display: flex;
  align-items: center;
`;
